document.addEventListener("DOMContentLoaded", function () {
  const domainLangMap = {
    "www.shopsta.fr": "fr",
    "www.shopsta.nl": "nl",
    "www.shopsta.be": window.location.pathname.startsWith("/fr/") ? "fr" : "nl",
    "www.shopsta.de": "de",
    "www.shopsta.it": "it",
    "www.shopsta.es": "es",
    "www.shopsta.pl": "pl",
    "www.shopsta.pt": "pt",
    "www.shopsta.se": "sv",
    "www.shopsta.dk": "dk",
    "www.shopsta.hu": "hu",
    "www.shopsta.ro": "ro",
    "www.shopsta.cz": "cs",
    "www.shopsta.at": "de",
    "www.shopsta.ch": "de",
    "www.shopsta.lt": "lt",
    "www.shopsta.lv": "lv",
    "www.shopsta.ee": "et",
    "www.shopsta.gr": "el",
    "www.shopsta.ie": null,
    "www.shopsta.co": null
  };

  let lang = domainLangMap[window.location.hostname] || null;

  // Special case: Belgium dual language
  if (window.location.hostname === "www.shopsta.be") {
    lang = window.location.pathname.startsWith("/fr/") ? "fr" : "nl";
  }

  // Special cases: .co with language subfolders
  if (window.location.hostname === "www.shopsta.co") {
    if (window.location.pathname.startsWith("/hr/")) lang = "hr";
    if (window.location.pathname.startsWith("/de/")) lang = "de";
  }

  if (!lang) return;

  const imgs = document.querySelectorAll(".description-content img");

  imgs.forEach((img) => {
    const src = img.getAttribute("src");
    if (!src || src.includes(`-lang-${lang}`)) return;

    const extIndex = src.lastIndexOf(".");
    const newSrc =
      src.slice(0, extIndex) + `-lang-${lang}` + src.slice(extIndex);

    fetch(newSrc, { method: "HEAD" })
      .then((res) => {
        if (res.ok) {
          img.src = newSrc;
        }
      })
      .catch(() => {});
  });
});